import React from "react";
import tagToWord from "../../../utils/tagToWord";
import Link from "../../../utils/link";
import { useStaticQuery, graphql } from "gatsby"

const TagHeader = (props) => {

    const tagList = props.tagList

    // limit to 4 tags

    const data = useStaticQuery(graphql`
    {
        filters: allStoryblokDatasourceEntry(
            filter: {parent: {}, data_source: {glob: "type-of-blog-journal"}}
          ) {
            edges {
              node {
                id
                value
                name
                data_source
              }
            }
          }
        
      }
      
  `)

  const filters = data.filters.edges.map((filter) => {
    return filter.node.value
})


    return (
        <nav className="absolute line-under-nav-height width pt-5 lg:pt-3 text-xs lg:text-lg hidden lg:flex z-10 uppercase">
            <ol className="space-x-2 lg:space-x-16">
                <li key={`scope-header-all`} className={`inline-block`}>
                                <Link to={`/journal/`} className={`blog-hover-underline-animation`}>{`All`}</Link>
                </li>  
                {
                    filters.map((tag, index) => {
                        const tagLink = tag === "all" ? `/journal/` : `/journal/?tag=${tag}`
                        const activeTag = tagList.includes(tag)
                        return (
                            <li key={`scope-header-${index}`} className={`inline-block`}>
                                <Link to={tagLink} className={`blog-hover-underline-animation ${activeTag ? `active` : ``}`}>{tagToWord(tag)}</Link>
                            </li>
                        )
                    })
                }
            </ol>
        </nav>
    )
}

export default TagHeader;